module.exports = __webpack_public_path__ + "img/iPhone13.0a51aa1d.png";